import React from 'react';
import { Accordion } from '@naf-simba/elements-accordion';
import { Text, TextVariant } from '@naf/text';
import { Checkbox } from '@naf-simba/elements-checkbox';
import { FilterOption } from '@appTypes/carFiltersType';
import { FilterType } from '@appTypes/urlParamsType';
import {
  AccordionContent,
  DesktopWrapper,
  ExpandableListWrapper,
  MobileWrapper,
  ShowMoreWrapper,
  SmallCheckboxWrapper,
} from './CarFilter.styles';

interface CheckboxEvent {
  name: keyof FilterType;
  value: boolean;
}

interface Props {
  title: string;
  options: FilterOption[] | undefined;
  checked: Record<string, boolean> | undefined;
  onChange: (e: CheckboxEvent) => void;
  // Truncate visible options on desktop + render a "Vis flere" button. Undefined = show all.
  maxVisible?: number;
  onShowMore?: () => void;
}

// Filter section laid out as a visible vertical list on desktop and a collapsible
// accordion on mobile. Used for the page's headline filters (chassis, categories).
const PrimaryFilterSection = ({ title, options, checked, onChange, maxVisible, onShowMore }: Props) => {
  if (!options || options.length === 0) return null;
  const visibleOptions = maxVisible ? options.slice(0, maxVisible) : options;
  const showMoreButton = maxVisible !== undefined && options.length > maxVisible && onShowMore;

  return (
    <>
      <DesktopWrapper>
        <ExpandableListWrapper>
          <Text tag="h3" variant={TextVariant.ArticleTextHeader}>
            {title}
          </Text>
          {visibleOptions.map((opt) => (
            <SmallCheckboxWrapper key={opt.name}>
              <Checkbox
                onChange={onChange}
                name={opt.name}
                label={`${opt.name} (${opt.count})`}
                checked={checked?.[opt.name] ?? false}
              />
            </SmallCheckboxWrapper>
          ))}
          {showMoreButton && (
            <ShowMoreWrapper onClick={onShowMore}>
              &#43; <span>Vis flere</span>
            </ShowMoreWrapper>
          )}
        </ExpandableListWrapper>
      </DesktopWrapper>
      <MobileWrapper>
        <Accordion headingLevel={3} title={title} size="medium">
          <AccordionContent>
            {options.map((opt) => (
              <SmallCheckboxWrapper key={opt.name}>
                <Checkbox
                  onChange={onChange}
                  name={opt.name}
                  label={`${opt.name} (${opt.count})`}
                  checked={checked?.[opt.name] ?? false}
                />
              </SmallCheckboxWrapper>
            ))}
          </AccordionContent>
        </Accordion>
      </MobileWrapper>
    </>
  );
};

export default PrimaryFilterSection;
